import Ajax from '../lib/ajax';
import { addVisible, removeVisible } from './helper';

const AJAX_CHECK_SCREENNAME = '1';
const AJAX_CHECK_SCREENNAME_OK = 1;
const CLS = '.validate--tooltip-screenname-reserve';

interface ScreennameResponse {
    status: number;
    screenNames?: Array<string>;
}

// Singletons woho...
let resolve: Function;
let reject: Function;

function reserve(screenname: string): Promise<ScreennameResponse> {
    if (reject) {
        reject(new Error('abort'));
    }
    const formData = new FormData();
    formData.append('ajaxCheckID', AJAX_CHECK_SCREENNAME);
    formData.append('ajaxCheckValue', screenname);
    const ajax = new Ajax();
    return new Promise((_resolve: Function, _reject: Function) => {
        resolve = _resolve;
        reject = _reject;
        return ajax
            .postFormData('/register.html', formData)
            .then((response: Response) => {
                return response.json();
            })
            .then((data: ScreennameResponse) => {
                _resolve(data);
            })
            .catch(() => {
                _reject(new Error('err'));
            });
    });
}

export function validateScreenname(element: HTMLInputElement): boolean {
    return !element.classList.contains(CLS);
}

export function liveReserveScreenname(element: HTMLInputElement) {
    const errorDiv = document.querySelector<HTMLDivElement>('#regScreenNameError .validate-html__content .options');

    let oldValue = '';

    function screenNameSelected(this: HTMLInputElement) {
        element.value = this.value;
        removeVisible(element, CLS);
        makeReserve();
    }

    function makeReserve() {
        if (!element.value) {
            // Nothing to reserve.
            return;
        }
        oldValue = element.value;
        reserve(element.value)
            .then((response: ScreennameResponse) => {
                if (response.status === AJAX_CHECK_SCREENNAME_OK) {
                    removeVisible(element, CLS);
                } else {
                    const parts = response.screenNames?.map((screenName: string) => {
                        return `<div class="availability__item frm__row"><input type="radio" name="screenNameSuggest" value="${screenName}" id="sn-${screenName}" class="frm__radio js-screenname-select"><label for="sn-${screenName}" class="frm__label">${screenName}</label></div>`;
                    });

                    if (errorDiv) {
                        errorDiv.innerHTML = parts?.join('') || '';
                        errorDiv.querySelectorAll('.js-screenname-select')?.forEach((item: HTMLInputElement) => {
                            item.addEventListener('change', screenNameSelected);
                        });
                    }
                    addVisible(element, CLS);
                    element.classList.add('focus-visible');
                }
            })
            .catch(() => {
                console.warn('cancelled');
            });
    }

    let maybeReserveRunningTimeout: number;
    const minLen = parseInt(element.getAttribute('minlength') as string, 10);
    function maybeReserve() {
        if (oldValue === element.value) {
            return;
        }
        if (!isNaN(minLen)) {
            if (element.value.length < minLen) {
                return;
            }
        }
        clearTimeout(maybeReserveRunningTimeout);
        removeVisible(element, CLS);
        maybeReserveRunningTimeout = window.setTimeout(makeReserve, 1000);
    }

    element.addEventListener('input', maybeReserve);
    element.addEventListener('change', maybeReserve);
}
